module.exports = __webpack_public_path__ + "img/gift-box.82a1037d.svg";